const ComputeUploadIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 10H2V14H13.2998L14 13H3V10Z" fill={fillColor} />
        <path d="M14 10H13V12H14V10Z" fill={fillColor} />
        <path
          d="M7.5 3.88065V12H8.5V3.88065L12.1514 7.43066L12.8486 6.71387L8 2L3.15137 6.71387L3.84863 7.43066L7.5 3.88065Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}

export default ComputeUploadIcon
